/**
 * Parse compact recheck decision messages:
 *   (A12)Name (9A) · subject -> Approved
 *   "examiner note"
 * Also accepts older long-form text and returns null so the UI can fall back.
 */
export function parseRecheckDecisionMessage(text) {
  const raw = String(text || '').trim();
  if (!raw) return null;

  const lines = raw.split(/\n+/).map((l) => l.trim()).filter(Boolean);
  const first = lines[0] || '';
  const arrow = first.lastIndexOf(' -> ');
  if (arrow !== -1) {
    const who = first.slice(0, arrow).trim();
    const status = first.slice(arrow + 4).trim();
    let note = '';
    if (lines[1]) {
      note = lines[1].replace(/^["“]|["”]$/g, '').trim();
    }
    const approved = /^approved$/i.test(status);
    const rejected = /^rejected$/i.test(status);
    if (!approved && !rejected) return null;
    return {
      who,
      status: approved ? 'Approved' : 'Rejected',
      approved,
      note
    };
  }

  // Legacy long notices
  const legacyApproved = /was approved/i.test(raw);
  const legacyRejected = /was rejected/i.test(raw);
  if (!legacyApproved && !legacyRejected) return null;
  const whoMatch = raw.match(/for\s+(.+?)\s+was\s+(approved|rejected)/i);
  const noteMatch = raw.match(/Examiner note:\s*(.+?)(?:\n|$)/i);
  return {
    who: whoMatch ? whoMatch[1].trim() : raw,
    status: legacyRejected ? 'Rejected' : 'Approved',
    approved: !legacyRejected,
    note: noteMatch ? noteMatch[1].trim() : ''
  };
}

export function RecheckDecisionBody({ text }) {
  const parsed = parseRecheckDecisionMessage(text);
  if (!parsed) {
    return <>{text}</>;
  }
  return (
    <>
      <div className="msg-recheck-line">
        <span className="msg-recheck-who">{parsed.who}</span>
        <span className="msg-recheck-arrow"> → </span>
        <span className={parsed.approved ? 'msg-status-approved' : 'msg-status-rejected'}>
          {parsed.status}
        </span>
      </div>
      {parsed.note ? (
        <div className="msg-examiner-note">"{parsed.note}"</div>
      ) : null}
    </>
  );
}
